import React from "react";
import CaroselloHome from "../components/home/CaroselloHome";
import "../styles/Home.css";
import { useNavigate } from "react-router-dom";
import GroupCard from "../components/home/GroupCard";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import TitoloSezioni from "../commons/TitoloSezioni";
import SpaceL from "../commons/SpaceL";
import CardNews from "../components/CardNews";
import CardInEvidenza from "../components/CardInEvidenza";
import CardNewsEvidenza from "../components/CardNewsEvidenza";
import CardNewsEvidenzaFoto from "../components/CardNewsEvidenzaFoto";
import CardInEvidenzaFoto from "../components/CardInEvidenzaFoto";
import { Helmet } from "react-helmet";

// Importa le immagini qui
import armadietti from "../images/Evidenza/card.jpg";
import inizioCorsi from "../images/Evidenza/Card_inizioCorsi.jpg";

interface HomeProps {}

function Home(_: HomeProps) {
    const navigate = useNavigate();

    return (
        <div>
            <Helmet>
                <title>Centro Sportivo Il Cigno</title>
                <meta name="description" content="Piscina, Palestra, Danza, Fitness, Runnering, SPA" />
                <link rel="preload" href={armadietti} as="image" />
            </Helmet>

            <ScrollToTopOnMount />
            <CaroselloHome />

            <div className="d-none d-sm-block"><Space /></div>
            <div className="d-block d-sm-none"><SpaceL /></div>

            <div className="m-auto" style={{ maxWidth: "90%" }}>
                <p style={{ fontSize: "1.8em", fontFamily: "Hammersmith One" }}>In evidenza</p>
                <hr />
                <div className="d-none d-sm-block">
                    <div style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                        <CardInEvidenzaFoto width={"85%"} foto={armadietti} posizioneFoto={"center"} indirizzo={"../news/armadietti"} />
                    </div>
                </div>
                <div className="d-sm-none">
                    <div className="card-container" style={{ display: "flex", flexDirection: "row", overflowX: "auto" }}>
                        <CardNewsEvidenzaFoto foto={armadietti} width={"100%"} posizioneFoto={"center"} indirizzo={"../news/armadietti"} />
                    </div>
                </div>
            </div>

            <div className="d-none d-sm-block"><Space /></div>
            <div className="d-block d-sm-none"><SpaceL /></div>

            <div className="d-flex flex-column align-items-center">
                <TitoloSezioni title="Attività" />
                <GroupCard />
                <Space />
                <figure className="text-center">
                    <blockquote className="blockquote">
                        <button
                            style={{ maxWidth: "40em", minWidth: "20em", height: "4em", borderRadius: "1em", borderColor: "#2F719DFF" }}
                            type="button" className="btn custom-btn"
                            onClick={() => navigate("/chisiamo")}
                        >
                            <h4>Scopri il centro</h4>
                        </button>
                    </blockquote>
                </figure>
            </div>

            <SpaceL />
            <Space />
        </div>
    );
}

export default Home;
